module.exports = __webpack_public_path__ + "static/img/1.7b31d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/1.png
// module id = FpaP
// module chunks = 1